
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

interface NavbarDesktopMenuProps {
  handleSectionClick: (sectionId: string) => void;
  solutionsOpen: boolean;
  setSolutionsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const NavbarDesktopMenu = ({ 
  handleSectionClick, 
  solutionsOpen, 
  setSolutionsOpen 
}: NavbarDesktopMenuProps) => {
  const { t } = useLanguage();
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!solutionsOpen) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setSolutionsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [solutionsOpen, setSolutionsOpen]);
  
  return (
    <nav className="flex items-center gap-6">
      <button 
        onClick={() => handleSectionClick("about")}
        className="text-sm font-medium hover:text-primary transition-colors dark:text-gray-200"
      >
        {t('about')}
      </button>
      
      {/* Solutions dropdown */}
      <div className="relative" ref={dropdownRef}>
        <button 
          className="text-sm font-medium hover:text-primary transition-colors flex items-center gap-1 dark:text-gray-200"
          onClick={() => setSolutionsOpen(!solutionsOpen)}
        >
          {t('solutions')}
          <ChevronDown className={`w-4 h-4 transition-transform ${solutionsOpen ? "rotate-180" : ""}`} />
        </button>
        
        <div 
          className={`absolute top-full left-0 mt-1 w-48 bg-white dark:bg-gray-800 rounded-md shadow-md overflow-hidden transition-all origin-top ${
            solutionsOpen ? "opacity-100 scale-100" : "opacity-0 scale-95 pointer-events-none"
          }`}
        >
          <Link 
            to="/arbitrinity" 
            className="block px-4 py-3 text-sm hover:bg-gray-50 dark:hover:bg-gray-700 dark:text-gray-200 transition-colors"
            onClick={() => setSolutionsOpen(false)}
          >
            Arbitrinity
          </Link>
        </div>
      </div>
      
      <button 
        onClick={() => handleSectionClick("contact")}
        className="text-sm font-medium hover:text-primary transition-colors dark:text-gray-200"
      >
        {t('contact')}
      </button>
    </nav>
  );
};

export default NavbarDesktopMenu;
